
<!-- Расчет ставки наращения -->

<template>

	<div>
		<!-- <div class="my-3">
			Формула Фишера: -->
			<!-- <img :src="formula" />, где -->
			<!-- <div style="font-size: .825rem;">Реальная норма доходности = (Номинальная норма доходности - Средний прогнозируемый темп инфляции) / (1 + Средний прогнозируемый темп инфляции)</div>
		</div> -->
		<!-- <b-card no-body >
			<b-card-header header-tag="header" class="p-1" role="tab">
				<b-button block v-b-toggle="'accordion-' + _uid" variant="grey" style="text-align: left;"
					class="d-flex justify-content-between"
				>
					Описание
					<b-icon-chevron-double-up class="when-opened" />
					<b-icon-chevron-double-down class="when-closed" />
				</b-button>
			</b-card-header>
			<b-collapse :id="'accordion-' + _uid" accordion="my-accordion" role="tabpanel">
				<b-table :fields="desc_fields" :items="formula_desc" thead-class="d-none" class="m-0">
					<template v-slot:cell()="data">
						<span v-html="data.value"></span>
					</template>
				</b-table>
			</b-collapse>
		</b-card> -->

		<element_row
			title="Прогнозируемый темп инфляции (год оценки + 1)" :data="data.year_1"
			:validation="fields['year_1']" v-on:set_value="(key, value) => set_value(`year_1.${key}`, value)"
			:readonly="!check_roles([ 'model' ]) || not_editable"
		/>

		<element_row
			title="Прогнозируемый темп инфляции (год оценки + 2)" :data="data.year_2"
			:validation="fields['year_2']" v-on:set_value="(key, value) => set_value(`year_2.${key}`, value)"
			:readonly="!check_roles([ 'model' ]) || not_editable"
		/>

		<element_row
			title="Прогнозируемый темп инфляции (год оценки + 3)" :data="data.year_3"
			:validation="fields['year_3']" v-on:set_value="(key, value) => set_value(`year_3.${key}`, value)"
			:readonly="!check_roles([ 'model' ]) || not_editable"
		/>

		<element_row
			title="Номинальная норма доходности" :data="data.nominal"
			:validation="fields['nominal']" v-on:set_value="(key, value) => set_value(`nominal.${key}`, value)"
			:readonly="!check_roles([ 'model' ]) || not_editable"
		/>

		<element_row title="Реальная норма доходности" :data="{ value : data.real }" readonly without_source not_required bold />

	</div>

</template>

<script>

import formula from "./formules/fisher.svg"
import api from "../../../../../../api"
import element_row from "../../../../../widgets/element-row"

export default
{
	props :
	{
		data : Object,
		not_editable : Boolean,
	},

	components :
	{
		element_row
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			formula,

			desc_fields :
			[
				{ key : "name", label : "", tdClass : "formula_cell", },
				{ key : "desc", label : "", tdClass : "formula_cell", }
			],

			formula_desc:
			[
				{ name : "<i>Y<sub>real</sub></i>", desc : "Реальная ставка наращения", },
				{ name : "<i>Y<sub>nom</sub></i>", desc : "Номинальная ставка наращения", },
				{ name : "<i>&lambda;</i>", desc : "Темп инфляции", },
			],

            fields: {
                "year_1":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
				"year_2":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
				"year_3":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                },
				"nominal":
                {
                    check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
                    msg: "От 0 до 1"
                }
            }
		}
	},

	methods :
	{
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

		set_value(key, value)
		{
			this.$emit("set_value", key, value)
		}
	}
}

</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>

